import {damsFetch} from "../../app/damsFetch";

/**
 * Reads how often a failed job was re-run and whether its failure was shown, from the job's
 * `operationcreated` log row (DE-1817).
 *
 * @param {string} jobId - The job to read.
 * @returns {Promise<{rerunCount: number, failureShown: boolean}>}
 * @throws When the log cannot be read or has no operationcreated row, so the caller fails closed.
 */
export const loadJobRerunState = async (jobId) => {
    const log = await damsFetch('/jobs/log', {
        method: 'POST',
        body: JSON.stringify({job_id: jobId}),
    });
    const created = log.models.find(row => row.message === 'operationcreated');
    if (!created) {
        throw new Error(`no operationcreated row for job ${jobId}`);
    }
    const details = created.messageDetails;
    return {
        rerunCount: details?.operation?.rerunCount ?? 0,
        failureShown: details?.failureShown === true,
    };
};
